import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { PinInput } from '../PinInput';
import { PhoneCallPinLayout } from '../PhoneCallPinLayout';
import { CountdownTimer } from '../CountdownTimer';
import { Link } from '../Link';
import * as styles from './styles.css';
export var ConfirmationCallCodeForm = function ConfirmationCallCodeForm(_ref) {
  var code = _ref.code,
      codeLength = _ref.codeLength,
      submitButtonText = _ref.submitButtonText,
      isCodeInvalid = _ref.isCodeInvalid,
      isSubmitting = _ref.isSubmitting,
      codeError = _ref.codeError,
      isResendCodeAvailable = _ref.isResendCodeAvailable,
      codeTimeout = _ref.codeTimeout,
      onCodeTimeoutExpired = _ref.onCodeTimeoutExpired,
      codeSendTimestamp = _ref.codeSendTimestamp,
      onCodeChange = _ref.onCodeChange,
      onResendCode = _ref.onResendCode,
      onSubmit = _ref.onSubmit,
      onCodeCleared = _ref.onCodeCleared;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isCodeCompleted = _React$useState2[0],
      setCodeCompleted = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isAutoSubmitDisabled = _React$useState4[0],
      setAutoSubmitDisabled = _React$useState4[1];

  var isTryAgain = isCodeInvalid && isCodeCompleted;
  React.useEffect(function () {
    if (isCodeInvalid) {
      setAutoSubmitDisabled(true);
    }
  }, [isCodeInvalid]);
  var handleInputSubmit = React.useCallback(function () {
    if (isSubmitting || isCodeInvalid) {
      return;
    }

    onSubmit();
  }, [isSubmitting, isCodeInvalid, onSubmit]);
  var handleButtonSubmit = React.useCallback(function () {
    if (isSubmitting) {
      return;
    }

    if (isTryAgain) {
      onCodeChange([]);

      if (onCodeCleared) {
        onCodeCleared();
      }

      return;
    }

    onSubmit();
  }, [isSubmitting, isTryAgain, onSubmit, onCodeChange, onCodeCleared]);
  var handleCodeCompletedChange = React.useCallback(function (isCompleted) {
    setCodeCompleted(isCompleted);

    if (isCompleted && !isSubmitting && !isAutoSubmitDisabled) {
      onSubmit();
    }
  }, [isSubmitting, isAutoSubmitDisabled, onSubmit]);
  var handlePreventSubmit = React.useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleResendCode = React.useCallback(function (e) {
    e.preventDefault();
    onResendCode();
  }, [onResendCode]);
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(PhoneCallPinLayout, {
    pinInput: /*#__PURE__*/React.createElement(PinInput, {
      value: code,
      length: codeLength,
      invalid: isCodeInvalid,
      disabled: isSubmitting,
      onChange: onCodeChange,
      onSubmit: handleInputSubmit,
      onCompletedChange: handleCodeCompletedChange
    }),
    errorMessage: codeError
  }), /*#__PURE__*/React.createElement(Button, {
    "data-name": "ConfirmCodeBtn",
    theme: "fill_primary",
    loading: isSubmitting,
    disabled: !isCodeCompleted,
    fullWidth: true,
    onClick: handleButtonSubmit
  }, isTryAgain ? 'Ввести заново' : submitButtonText), /*#__PURE__*/React.createElement("div", {
    className: styles['toggle-to-sms']
  }, /*#__PURE__*/React.createElement(Link, {
    href: "#",
    onClick: handleResendCode,
    disabled: !isResendCodeAvailable
  }, "\u041C\u043D\u0435 \u043D\u0435 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B\u0438", !isResendCodeAvailable && codeSendTimestamp && codeTimeout && /*#__PURE__*/React.createElement(CountdownTimer, {
    fromTimestamp: codeSendTimestamp,
    timeout: codeTimeout,
    onTimeoutExpired: onCodeTimeoutExpired
  }, function (_ref2) {
    var timeLeft = _ref2.timeLeft;
    return /*#__PURE__*/React.createElement(React.Fragment, null, " (", timeLeft, " \u0441\u0435\u043A.)");
  }))));
};
ConfirmationCallCodeForm.displayName = 'ConfirmationCallCodeForm';